<template>
  <div class="limits-list">

    <div class="container-header">
      <div class="container-header__title">{{ i18n.lim_limits_requests() }}</div>
    </div>

    <md-table class="container container_40  limits-list__table scrollbar">
      <template v-if="list.length">
        <md-table-row class="limits-list__row">
          <md-table-head>{{ i18n.lim_date() }}</md-table-head>
          <md-table-head>{{ i18n.lbl_request_type() }}</md-table-head>
          <md-table-head>{{ i18n.lim_state() }}</md-table-head>
          <md-table-head>{{ i18n.lim_asset() }}</md-table-head>
          <md-table-head><!-- upload docs button --></md-table-head>
        </md-table-row>
        <template v-for="(request, i) in list">
          <md-table-row class="limits-list__table-row" :key="i">
            <md-table-cell class="limits-list__table-cell text_medium">{{ i18n.d(request.createdAt) }}</md-table-cell>
            <md-table-cell class="limits-list__table-cell text_medium">{{ LIMITS_REQUEST_TYPE_STR[get(request, 'details.requestType', '-')] }}</md-table-cell>
            <md-table-cell class="limits-list__table-cell text_medium">{{ getState(request.state) }}</md-table-cell>
            <md-table-cell class="limits-list__table-cell text_medium">{{ get(request, 'tokenCode', '-')}}</md-table-cell>
            <md-table-cell class="limits-list__table-cell text_medium">
              <md-button :disabled="request.state !== REQUEST_STATES_STR.rejected"
                          @click="viewRequest(request)">{{i18n.lim_upload_documents_btn()}}</md-button>
            </md-table-cell>
          </md-table-row>
        </template>
      </template>
      <template v-else>
        <div class="limits-list__no-requests">
          <md-icon class="md-size-4x">trending_up</md-icon>
          <h2 class="limits-list__no-requests-header">{{ i18n.lim_no_changing_requests() }}</h2>
          <p>{{ i18n.lim_no_changing_requests_desc() }}</p>
        </div>
      </template>
    </md-table>
    <div class="btn-wrap margin-top">
      <md-button class="btn md-primary" @click="loadNext()">{{i18n.lbl_more()}}</md-button>
    </div>
    <modal v-if="isUploadingDocs"
          @close-request="isUploadingDocs = false"
          maxWidth="30rem">
      <documents-uploader :request="selectedRequest"
                          @close-request="isUploadingDocs = false"/>
    </modal>
  </div>
</template>

<script>
  import { i18n } from '@js/i18n'
  import {
    REQUEST_STATES_STR,
    LIMITS_REQUEST_TYPE_STR
  } from '@const'
  import Modal from '../common/Modal'
  import DocumentsUploader from './Limits.DocumentsUploader'
  import get from 'lodash/get'
  import { mapActions } from 'vuex'
  import { vuexTypes } from '@vuex/types'

  export default {
    components: {
      Modal,
      DocumentsUploader },
    props: ['list'],
    data: _ => ({
      i18n,
      isUploadingDocs: false,
      selectedRequest: null,
      REQUEST_STATES_STR,
      LIMITS_REQUEST_TYPE_STR
    }),
    methods: {
      get,
      ...mapActions({
        loadNext: vuexTypes.NEXT_LIMITS_REQUESTS
      }),
      viewRequest (request) {
        this.selectedRequest = request
        this.isUploadingDocs = true
      },
      getState (state) {
        if (state === REQUEST_STATES_STR.permanentlyRejected) {
          return REQUEST_STATES_STR.rejected
        } else if (state === REQUEST_STATES_STR.rejected) {
          return i18n.lbl_requesting()
        } else {
          return state
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/vue/app/limits/Limits.List.vue